/*
  **************************************************************************
  common js
  **************************************************************************
*/

import axios from 'axios';

import api from '../../api/index'

const common = {};

const accountData = JSON.parse(localStorage.getItem('accountData'));
console.log('this.accountData---------->', accountData);

/**
 * config
 */
common.config = {
    lang: localStorage.getItem('lang') || 'cn',
    navigation: [
        // {
        //     id: '1',
        //     cnName: '首页',
        //     enName: 'home',
        //     path: '/home',
        // },
        {
            id: '1',
            cnName: '产品',
            enName: 'Product',
            children: []
        },
        {
            id: '2',
            cnName: '解决方案',
            enName: 'Solution',
            children: []
        },
        {
            id: '3',
            cnName: '技术支持',
            enName: 'Support',
            path: '/support'
        },
        {
            id: '4',
            cnName: '客户故事',
            enName: 'Story',
            path: '/story'
        },
        {
            id: '5',
            cnName: '关于我们',
            enName: 'About',
            path: '/about'
        },
    ],
    language: [
        {
            key: 'cn',
            name: '简体中文',
            icon: 'static/icon/language-cn@24px.png',
        },
        {
            key: 'en',
            name: 'English-US',
            icon: 'static/icon/language-en@24px.png',
        },
        // {
        //     key: 'fn',
        //     name: 'France',
        //     icon: 'static/icon/language-fn@24px.png',
        // }
    ],
};

// 获取窗口尺寸
common.content = {
    width: window.innerWidth,
    height: window.innerHeight,
};

/**
 * 验证是否合法手机号
 * @param data
 */
common.isPhoneNumber = (data)=> {
    // debugger
    let reg = /^1(3[0-9]|4[5,7]|5[0,1,2,3,5,6,7,8,9]|6[2,5,6,7]|7[0,1,7,8,6]|8[0-9]|9[1,8,9])\d{8}$/;
    if (!reg.test(data) || !data.length === 11) {
        return false;
    } else {
        return true;
    }
};

/**
 * 验证只能输入英文字母和数字
 * @param data
 */
common.isEnglishNumber = (data)=> {
    // debugger
    if(/.*[\u4e00-\u9fa5]+.*$/.test(data)) {
        return false;
    } else {
        return true;
    }
};

/**
 * 取两个集合的交集
 * @param a
 * @param b
 * @returns 结果集合
 */
function intersect(a, b) {
    let set1 = new Set(a), set2 = new Set(b);
    return [...new Set([...set1].filter(x => set2.has(x)))];
}

common.intersectArray = function(a, b) {
    let set1 = new Set(a), set2 = new Set(b);
    return [...new Set([...set1].filter(x => set2.has(x)))];
};

common.difference = function(a, b) {
    let set1 = new Set(a), set2 = new Set(b);
    return [...new Set([...set1].filter(x => !set2.has(x))), ...new Set([...set2].filter(x => !set1.has(x)))];
};

/**
 * 是否有权限
 * @param permissions 权限功能集
 * @returns {boolean}
 */
common.isPermissions = function (permissions) {
    // debugger
    if (accountData.roleId === 0 || common.isAdmin()){
        return true;
    }
    return accountData && accountData.permissions ? !!intersect(permissions, accountData.permissions).length : false;
};

/**
 * 将 file 转换为 BASE64
 * @param data
 * @returns {string|boolean}
 */
common.fileToBase = function (data) {
    if (!data || data === ''){
        return false;
    }
    let reader = new FileReader();
    reader.readAsDataURL(data);
    reader.onloadend = function (e) {
        data.url = reader.result;
    };
    console.log(data.url);
    return data;
};

/**
 * 截取文件后缀名
 * @param data
 */
common.fileExtensionName = function (data) {
    //获取文件名，不带后缀
    var fileName = data;

    var strFileName = fileName.replace(/(.*\/)*([^.]+).*/ig, "$2");

    // 获取文件后缀
    var FileExt = fileName.replace(/.+\./, "");
    var fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1);

    //截取文件后缀
    var reg = /\.\w+$/;
    var file_name = fileName.replace(reg, '');

    return fileExtension;
};

/**
 * 判断文件类型
 */
common.assetsFilesType = (data)=> {
    let image = ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'];
    let video = ["mp4", "m2v", "mkv"];
    if (image.indexOf(common.fileExtensionName(data)) !== -1){
        return 1; // 图片类
    }
    if (image.indexOf(common.fileExtensionName(data)) !== -1){
        return 2; // 文件类
    }
    if (video.indexOf(common.fileExtensionName(data)) !== -1){
        return 3; // 视频类
    }
    return 4; // 其他类型
};

/**
 * 验证是否合法URL
 * @param URL
 * @returns {boolean}
 */
common.isCheckedURL = function (URL) {
    let http = URL,
        Expression = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/,
        objExp = new RegExp(Expression);
    if (objExp.test(http) === true) {
        return true;
    } else {
        return false;
    }
};

/**
 * 提示框 confirmModel
 * @param content
 * @returns {Promise<unknown>}
 */
common.confirmModel = function (content, errMsg) {
    return new Promise(((resolve, reject) => {
        window.VUE.$Modal.confirm({
            title: '系统提示',
            content: content,
            onOk: () => {
                return true;
            },
            onCancel: () => {
                return false;
            },
        })
    }))
};

common.alertModel = function (type, content) {
    let title = '系统提示';
    return new Promise(((resolve) => {
        if (type === 'info'){
            window.VUE.$Modal.info({
                title: title,
                content: content,
                onOk: () => {
                    resolve()
                }
            })
        }
        if (type === 'success'){
            window.VUE.$Modal.success({
                title: title,
                content: content,
                onOk: () => {
                    resolve()
                }
            })
        }
        if (type === 'warning'){
            window.VUE.$Modal.warning({
                title: title,
                content: content,
                onOk: () => {
                    resolve()
                }
            })
        }
        if (type === 'error'){
            window.VUE.$Modal.error({
                title: title,
                content: content,
                onOk: () => {
                    resolve()
                }
            })
        }
    }))
};

/**
 * 获取：所有启用产品
 */
common.product = async ()=> {
    let res = await api.getHttp('common/product?lang=' + common.config.lang);
    // debugger
    if (!res.data.success){
        throw new Error(res.data.message);
    }
    let data = [] = res.data.data.data;
        data.forEach(item => {
            item.path = '/product'
        });
    window.VUE.$nextTick(()=>{
        common.config.navigation[0].children = [] = data;
    });
    return res.data.data.data;
};

/**
 * 获取：所有启用解决方案
 */
common.solution = async ()=> {
    let res = await api.getHttp('common/solution?lang=' + common.config.lang);
    // debugger
    if (!res.data.success){
        throw new Error(res.data.message);
    }
    let data = [] = res.data.data.data;
    data.forEach(item => {
        item.path = '/solution'
    });
    window.VUE.$nextTick(()=>{
        common.config.navigation[1].children = [] = data;
    });
    return res.data.data.data;
};

/**
 * 产品：软件下载
 * @param type 下载的是什么版本：trial - 试用版 / formal - 正式版
 * @returns {Promise<*>}
 */
common.productDownload = async (data, type)=> {
    console.log('this.productDownload---------->', data, type);
    if (!data || !type){
        return false;
    }
    if (type === 'trial'){
        window.open(data.trialUrl);
    }
    if (type === 'formal'){
        window.open(data.formalUrl);
    }
};

/**
 * 数组排序
 * @param key --- 排序类型 index - 索引  date - 日期  time - 时间
 * @returns {*}
 */
common.arraySorting = (key)=> {
    if (key === 'createTime'){
        return (a, b) => {
            return b.createTime - a.createTime;
        };
    }
    // todo
};

/**
 * 获取本地模拟数据
 * page: 页面模块名称
 * type: 数据类型
 */
common.getLocalhostData = async (type)=> {
    if (!type || type === ''){
        return false;
    }
    let urls = '';
    switch (type) {
        case 'banner':
            urls = 'static/json/banner.json';
            break;
        case 'summary':
            urls = 'static/json/summary.json';
            break;
        case 'features':
            urls = 'static/json/features.json';
            break;
        case 'price':
            urls = 'static/json/price.json';
            break;
        case 'story':
            urls = 'static/json/story.json';
            break;
        case 'product':
            urls = 'static/json/product.json';
            break;
    }
    let res = await axios.get(urls);
    // debugger
    if (!res.data.success){
        throw new Error('获取失败！');
    }
    return res.data.data;
};

/**
 * 读区本地word文件
 * @param name
 * @returns {Promise<void>}
 */
common.getLocalhostWord = async (name)=> {
    if (!name || name === ''){
        return false;
    }

    const http = new XMLHttpRequest();
    let file = 'static/product/' + name + '.docx';
    http.open("get", file, true);
    http.responseType = "arraybuffer";
    http.onload = ()=> {
        if (http.status === 200) {
            window.VUE.$mammoth.convertToHtml({
                arrayBuffer: new Uint8Array(http.response)
            }).then((res)=> {
                // window.VUE.$nextTick(() => {
                    // console.log('common.getLocalhostWord---------->', res);
                // });
            });
        }
    };
    return http.send();
};

export default common;



// WEBPACK FOOTER //
// ./src/assets/js/common.js